import React, { createContext, useEffect, useRef, useState,useCallback } from 'react'


export const ApiContext = createContext();

function ApiContextProvider({ children }) {
  const [myNews, setMyNews] = useState(null)
  const [isApple, setIsApple] = useState(false);
  const days = [
    { id: "hge3d7", day: "Sunday" },
    { id: "hge3d1", day: "Monday" },
    { id: "hge3d2", day: "Tuesday" },
    { id: "hge3d3", day: "Wednesday" },
    { id: "hge3d4", day: "Thursday" },
    { id: "hge3d5", day: "Friday" },
    { id: "hge3d6", day: "Saturday" },
  ]
  const [songData, setSongData] = useState("Syntheticsax - Calm")
  const [schedule, setSchedule] = useState(null);
  const [data, setData] = useState(null);
  const [AllEvents, setAllEvents] = useState([])
  const date = new Date();
  const [myDay, setMyDay] = useState(days[date.getDay()].day)
  const interviewsaudioRef = useRef(null);
  const [audioSrc, setAudioSrc] = useState(null);
  const [audioSrc555, setAudioSrc555] = useState(null);
  const [currentTime55, setCurrentTime55] = useState(0);
  const [duration55, setDuration55] = useState(0);
  const [changedAudioUrl, setChangedAudioUrl] = useState(null)
  const [interviewsisPlaying, setinterviewsisPlaying] = useState(false);
  const [rss, setRss] = useState(null);
  const [image, setImage] = useState(null);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const innerAudioRef = useRef(null);
  const [isPlayings, setIsPlayings] = useState(false);
  const [Categories, setCategories] = useState([]);
  const [Categories2, setCategories2] = useState([]);
  const [Categories3, setCategories3] = useState([]);
  const [Categories3_id, setCategories3_id] = useState(null);
  const [isMetadataLoading, setIsMetadataLoading] = useState(true);
  const [isPlayingOrNot, setIsPlayingOrNot] = useState(false);
   const [deferredPrompt, setDeferredPrompt] = useState(null);
  const audioRef = useRef(null);
  const [analyzerData, setAnalyzerData] = useState(null);
  const audioCtxRef = useRef(null);
  const sourceRef = useRef(null);
  const togglePlayPause = () => {
    setIsPlayingOrNot(prev => !prev);
  };
  const togglePlayPause5 = () => {
    setIsPlayings(prev => !prev);
  };
  const interviewstogglePlayPause = () => {
    // if (interviewsisPlaying) {
    //   interviewsaudioRef.current.pause();
    // } else {
    //   interviewsaudioRef.current.play();
    // }
    setinterviewsisPlaying(prev => !prev);
  };
  const audioAnalyzer = () => {
    console.log("i am working",analyzerData);
    // console.log(audioCtxRef.current,"audiocatxRef" ,sourceRef.current,"sourceRef");
    
    if (!audioCtxRef.current) {
      audioCtxRef.current = new (window.AudioContext || window.webkitAudioContext)();
      // console.log("i am in audioCtxRef");
    }
    
    if (!sourceRef.current) {
      // console.log("i am in sourceRef",sourceRef.current);
      sourceRef.current = audioCtxRef.current.createMediaElementSource(audioRef.current);
      const analyzer = audioCtxRef.current.createAnalyser();
      analyzer.fftSize = 2048;

      const bufferLength = analyzer.frequencyBinCount;
      const dataArray = new Uint8Array(bufferLength);

      sourceRef.current.connect(analyzer);
      sourceRef.current.connect(audioCtxRef.current.destination);

      setAnalyzerData({ analyzer, bufferLength, dataArray });
    }
  };

  // useEffect(() => {
  //   if (isPlayingOrNot) {
  //     if (innerAudioRef.current) {
  //       innerAudioRef.current.play(); 


  //       if (isPlayings) {
  //         if (audioRef.current) {
  //           audioRef.current.pause(); 
  //           setIsPlayings(prev => !prev); 
  //         }
  //       }


  //       if (interviewsisPlaying) {
  //         if (interviewsaudioRef.current) {
  //           interviewsaudioRef.current.pause(); 
  //           setinterviewsisPlaying(prev => !prev);
  //         }
  //       }
  //     }
  //   }else  if (interviewsisPlaying) {
  //     if (interviewsaudioRef.current) {
  //       interviewsaudioRef.current.play();
  //     }

  //     if (isPlayings) {
  //       if (audioRef.current) {
  //         audioRef.current.pause(); 
  //         setIsPlayings(prev => !prev);
  //       }
  //     }

  //     if (isPlayingOrNot) {
  //       if (innerAudioRef.current) {
  //         innerAudioRef.current.pause(); 
  //       }
  //     }
  //   }
  //   else {
  //     if (innerAudioRef.current) {
  //       innerAudioRef.current.pause();
  //     }
  //     if (interviewsaudioRef.current) {
  //       interviewsaudioRef.current.pause(); 
  //     }
  //   }
  // });




  // Effect for main audio (innerAudioRef)
  useEffect(() => {
    if (isPlayingOrNot && innerAudioRef.current) {
      innerAudioRef.current.play();
      setIsPlayings(false);
      audioRef.current.currentTime = 0;
      setinterviewsisPlaying(false);
    } else if (!isPlayingOrNot && innerAudioRef.current) {
      innerAudioRef.current.pause();
    }
  }, [isPlayingOrNot]);

  // Effect for interview audio (interviewsaudioRef)
  useEffect(() => {
    if (interviewsisPlaying && interviewsaudioRef.current) {
      interviewsaudioRef.current.play();
      setIsPlayingOrNot(false);
      setIsPlayings(false);
      audioRef.current.currentTime = 0;
    } else if (!interviewsisPlaying && interviewsaudioRef.current) {
      interviewsaudioRef.current.pause();
    }
  }, [interviewsisPlaying]);

  // Effect for toggling other audio (audioRef)
  useEffect(() => {
    if (isPlayings && audioRef.current) {
      // console.log("i run againnnnnnn");
      
      if (audioRef.current.readyState >= 2) {
        // ReadyState >= 2 ensures the audio is loaded enough to start playback
        audioRef.current.play();
        audioAnalyzer()
      }
      setIsPlayingOrNot(false);
      setinterviewsisPlaying(false)
    } else if (!isPlayings && audioRef.current) {      
      audioRef.current.pause();
      audioRef.current.load();
      // audioRef.current.currentTime = 0;
    }
  }, [isPlayings]);










  // useEffect(() => {
  //   else {
  //     if (interviewsaudioRef.current) {
  //       interviewsaudioRef.current.pause(); 
  //     }
  //   }
  // }, [interviewsisPlaying, isPlayings, isPlayingOrNot, innerAudioRef, audioRef, interviewsaudioRef, setIsPlayings]);



  const handleTimeUpdate = () => {
    setCurrentTime(innerAudioRef.current.currentTime);
  };
  const interviewshandleTimeUpdate = () => {
    setCurrentTime55(interviewsaudioRef.current.currentTime);
    setDuration55(interviewsaudioRef.current.duration);
  };


  // const handleLoadedMetadata = () => {
  //   setDuration(innerAudioRef.current.duration);
  //   if (duration) {
  //     setIsMetadataLoading(false);
  //   }
  //   // console.log(isMetadataLoading,"======================= m ===========");

  // };
  // useEffect(() => {
  //   // if(handleLoadedMetadata){
  //   //   console.log("i have called once");
  //   //   setIsMetadataLoading(false);

  //   // }
  //   setIsMetadataLoading(true)
  //   handleLoadedMetadata()
  // }, [handleLoadedMetadata])
  const handleLoadedMetadata = useCallback(() => {
    if (innerAudioRef.current) {
      const audioDuration = innerAudioRef.current.duration;
      if (!isNaN(audioDuration) && audioDuration > 0) {
        setDuration(audioDuration);
        setIsMetadataLoading(false);
      }
    }
  }, [setDuration, setIsMetadataLoading]);
  
  useEffect(() => {
    setIsMetadataLoading(true);
    handleLoadedMetadata();
  }, [handleLoadedMetadata]);

  return (
    <ApiContext.Provider value={{ togglePlayPause, isPlayingOrNot, setIsPlayingOrNot, audioRef, data, setData, Categories, setCategories, Categories2, setCategories2, rss, setRss, image, setImage, Categories3, setCategories3, Categories3_id, setCategories3_id, togglePlayPause5, isPlayings, setIsPlayings, innerAudioRef, changedAudioUrl, setChangedAudioUrl, currentTime, setCurrentTime, duration, setDuration, audioSrc, setAudioSrc, handleTimeUpdate, handleLoadedMetadata, isMetadataLoading, setIsMetadataLoading, songData, setSongData, days, myDay, setMyDay, schedule, setSchedule, myNews, setMyNews, interviewsaudioRef, interviewshandleTimeUpdate, currentTime55, setCurrentTime55, duration55, setDuration55, audioSrc555, setAudioSrc555, interviewsisPlaying, setinterviewsisPlaying, interviewstogglePlayPause, AllEvents, setAllEvents, isApple, setIsApple,deferredPrompt, setDeferredPrompt,analyzerData, setAnalyzerData,audioCtxRef,sourceRef,audioAnalyzer }} >
      {children}
    </ApiContext.Provider>

  )
}

export default ApiContextProvider